import React from 'react'

const intro = () => {
  return (
    <div>
      <h3 className='title'>Introdução</h3>
      <div className='description'>Nos tempos antigos, quando reinos distantes eram governados por reis sábios e as florestas eram habitadas por criaturas místicas, vivia um cavaleiro cujo nome era sinônimo de bravura e honra: Sir Eliot. Nascido na pequena vila de Eldoria, ele era conhecido por sua determinação e coragem desde a juventude.</div>

    </div>
  )
}

export default intro